import React from "react";
import Modal from "../../../components/ui/Modal";
import { Button } from "../../../components/ui/Buttons";
import CloseIcon from "../../../components/Icon/Close";
import { InputForm } from "../../../components/Modal/Input";
import { withStyles } from "@material-ui/core";
import { ReactSelect } from "../../../components/Select/SelectSearch";
import { observer } from "mobx-react-lite";
import { inject } from "mobx-react";
import { TextFieldSearch } from "../../../components/TextField";
import { findAllMotivoCancelamentoLimitado } from "../../../services/MotivoCancelamentoService";

const optionsCanceladoPor = [
  { value: "PACIENTE", label: "Paciente" },
  { value: "MEDICO", label: "Médico" },
  { value: "CLINICA", label: "Clínica" },
];

const ModalMotivoCancelamento = observer(
  ({ classes, isOpen, onClose, atendimentoStore, handleClickAgendar ,utilizaMotivoDeCancelamentoDoAgendamento}) => {
    const { objView } = atendimentoStore;
    const {
      motivoCancelamento,
      quemCancelou,
      motivoCancelamentoFixo,
    } = objView;


    const fieldMotivoCancelamentoPreenchido = utilizaMotivoDeCancelamentoDoAgendamento === "FIXO" ? motivoCancelamentoFixo : motivoCancelamento;
    const disabled = !fieldMotivoCancelamentoPreenchido || !quemCancelou;

    const handleMotivoCancelamentoLimitadoLoadOptions = async (
      search,
      loadedOptions,
      { page }
    ) => {
      try {
        const variables = {
          search,
          pageableDTO: {
            pageNumber: 0,
            pageSize: 10,
            sortField: "descricao",
            sortDir: "ASC",
          },
        };

        const response = await findAllMotivoCancelamentoLimitado(variables);

        const { content, last } = response;
        return {
          options: content,
          hasMore: !last,
          additional: {
            page: page + 1,
          },
        };
      } catch (error) {
        console.error(error);
      }
    };

    const handleChangeMotivoCancelamento = (value, field) => {
      atendimentoStore.objView[field] = value;
    };

    const handleClickSave = () => {
      try {
        handleClickAgendar && handleClickAgendar();
        onClose();

      } catch (error) {
        const notification = {
          isOpen: true,
          message: 'Erro ao salvar o agendamento.',
          variant: 'error',
        }
        atendimentoStore.showAlertMessage(notification);
      }
    };

    const handleCloseModal = () => {
      atendimentoStore.objView = {
        ...atendimentoStore.objView,
        motivoCancelamento: null,
        quemCancelou: null,
        motivoCancelamentoFixo: null,
      };

      onClose();
    };

    return (
      <Modal isOpen={isOpen}>
        <div className={classes.container}>
          <div className={classes.header}>
            <span className={classes.title}>Motivo do cancelamento</span>
            <Button
              bgColor={"#FB6D6D"}
              color={"#fff"}
              kind="transparent"
              shape="circle"
              onClick={handleCloseModal}
              size={"mini"}
              id="agd-mmc-btn-cls"
            >
              <CloseIcon />
            </Button>
          </div>
          <div className={classes.content}>
            <div>
              <span> Cancelado por: </span>
              <ReactSelect
                placeholder={"Selecione"}
                value={quemCancelou}
                options={optionsCanceladoPor}
                onChange={(e) =>
                  handleChangeMotivoCancelamento(e, "quemCancelou")
                }
                className={classes.reactSelect}
                id="agd-mmc-sel-cnc"
              />
            </div>
            <div className={classes.field}>
              <span> Motivo: </span>
              {utilizaMotivoDeCancelamentoDoAgendamento === "FIXO" ? (
                <TextFieldSearch
                  placeholder="Selecione"
                  classNotched={classes.notchedOutline}
                  classInput={classes.inputTextField}
                  loadOptions={handleMotivoCancelamentoLimitadoLoadOptions}
                  withPaginate
                  value={motivoCancelamentoFixo}
                  getOptionLabel={(option) => option.descricao}
                  onChange={(e) =>
                    handleChangeMotivoCancelamento(e, "motivoCancelamentoFixo")
                  }
                  debounceTimeout={300}
                  additional={{
                    page: 0,
                  }}
                  id="agd-mmc-sel-mot"
                />
              ) : (
                <InputForm
                  value={motivoCancelamento}
                  onChange={(e) =>
                    handleChangeMotivoCancelamento(
                      e.target.value,
                      "motivoCancelamento"
                    )
                  }
                  id="agd-mmc-inp-mot"
                />
              )}
            </div>
          </div>
          <div className={classes.contenButton}>
            <Button onClick={handleClickSave} className={classes.button} disabled={disabled} id="agd-mmc-btn-slv">
              Salvar
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
);

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    height: "fit-content",
    width: "300px",
    backgroundColor: "#fff",
    borderRadius: "16px",
    padding: "20px",
    gap: "17px",
  },
  header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    height: "48px",
  },
  title: {
    fontSize: "15px",
    fontWeight: "700",
    color: "#505050",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
    gap: "16px",
  },
  button: {
    width: "100px",
  },
  contenButton: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
  },
  notchedOutline: {
    border: '0',
  },
  inputTextField: {
    background: '#F2F2F2',
    color: '#505050',
    borderRadius: '8px',
    height: '30px',
  },
  reactSelect: {
    width: "100%",
  },
  field: {
    display: "flex",
    flexDirection: "column",
  }
};

const ModalMotivoCancelamentoWithStyles = withStyles(styles)(
  ModalMotivoCancelamento
);
export default inject("atendimentoStore")(ModalMotivoCancelamentoWithStyles);
